import { color, rem } from '@thiememeulenhoff/lit-sdk/src';
import { css } from 'lit';

export const sliderStyles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
    }

    .slider {
      accent-color: ${color('blue', 500)};
      color: ${color('grey', 700)};
    }

    :where(label) {
      font-size: ${rem(16)};
      font-weight: bold;
    }
  `,
];
